var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text_hover_container"},[_vm._t("baseText"),_c('span',{staticClass:"text_hover"},[_vm._v(_vm._s(_vm.message))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }